import React, { createContext, useState, useEffect, use } from 'react';

export const UserContext = createContext();

export const User = ({ children }) => {
  const [user, setUser] = useState(() => {
    const storedUser = localStorage.getItem('xceedEdge_user');
    return storedUser ? JSON.parse(storedUser) : null;
  });



  useEffect(() => {
    if (user) {
      localStorage.setItem('xceedEdge_user', JSON.stringify(user));
    } else {
    //   localStorage.removeItem('xceedEdge_user');
    }
  }, [user]);

  

  return (
    <UserContext.Provider value={{ user, setUser }}>
      {children}
    </UserContext.Provider>
  );
};